/**

 * @type {string}
 */
export const C_EVENTS_MODAL_INSTITUTION_OPEN = 'c_events_modal_institution_open'

export const C_EVENTS_BREADCRUMB_INIT = 'c_events_breadcrumb_init'
